import React, { useState, useEffect, useTransition } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPending, startTransition] = useTransition();
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem('token');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path) => {
    startTransition(() => {
      navigate(path);
    });
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-gray-900/80 backdrop-blur-md border-b border-gray-800' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button 
            onClick={() => handleNavigation('/')} 
            className="text-2xl font-bold text-white hover:text-indigo-400 transition-colors"
          >
            ShortStai
          </button>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => handleNavigation('#features')} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Features
            </button>
            <button 
              onClick={() => handleNavigation('#solutions')} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Solutions
            </button>
            <button 
              onClick={() => handleNavigation('#pricing')} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              Pricing
            </button>
            <button 
              onClick={() => handleNavigation('#about')} 
              className="text-gray-300 hover:text-white transition-colors"
            >
              About
            </button>
          </nav>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            {!isAuthenticated && (
              <button
                onClick={() => handleNavigation('/login')}
                className="text-gray-300 hover:text-white transition-colors"
                disabled={isPending}
              >
                Login
              </button>
            )}
            <button
              onClick={() => handleNavigation(isAuthenticated ? '/dashboard' : '/signup')}
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
              disabled={isPending}
            >
              {isAuthenticated ? 'Dashboard' : 'Start Free Trial'}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;